// Module
var code = "<sb-team-user-card class=\"sb-team-card-user\" member=\"$ctrl.mappedMember\" is-edit-allowed=\"true\" on-edit-member-click=\"$ctrl.onEditInvitationClick()\"> </sb-team-user-card> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/teams/components/invited_member_card/invited_member_card.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;